import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';
import config from './config';

// Configure global AJAX settings
axios.defaults.withCredentials = true; // Allow cross-domain requests with credentials
axios.defaults.timeout = 30000; // Set timeout to 30 seconds

// 检查和清理路径函数
function checkPath(pathToCheck) {
  // 清理路径 - 移除末尾斜杠
  const cleanedPath = pathToCheck.endsWith('/') 
    ? pathToCheck.slice(0, -1) 
    : pathToCheck;
  
  return cleanedPath;
}

// 验证路径是否匹配
function isValidPath(currentPath, expectedPath) {
  // 清理两个路径以确保一致的比较
  const cleanCurrentPath = checkPath(currentPath);
  const cleanExpectedPath = checkPath(expectedPath);
  
  // 检查当前路径是否与期望路径匹配或是子路径
  return cleanCurrentPath === cleanExpectedPath || 
         cleanCurrentPath.startsWith(cleanExpectedPath + '/');
}

// Log environment and app configuration for debugging
console.log('Environment variables:', {
  NODE_ENV: process.env.NODE_ENV,
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  PUBLIC_URL: process.env.PUBLIC_URL,
  BASE_PATH: config.BASE_PATH,
  CURRENT_PATH: window.location.pathname
});

// Check if we're accessing the correct path
if (process.env.NODE_ENV === 'development') {
  const expectedBasePath = checkPath(config.BASE_PATH);
  const currentPath = window.location.pathname;
  
  if (!isValidPath(currentPath, expectedBasePath)) {
    console.warn(`You are accessing the app from ${currentPath}, but it's configured to use ${expectedBasePath}`);
    console.info(`Consider accessing the app via: http://${window.location.host}${expectedBasePath}`);
  } else {
    console.log(`Accessing app from a valid path: ${currentPath}`);
  }
}

// Create root for React app
const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error('Root element not found in the DOM! App cannot mount.');
} else {
  console.log('Root element found, mounting React app...');
  
  try {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
    console.log('React app mounted successfully.');
  } catch (error) {
    console.error('Failed to mount React app:', error);
    
    // Display error directly in DOM if mounting fails
    if (rootElement) {
      const currentPath = window.location.pathname;
      const basePathWithoutSlash = checkPath(config.BASE_PATH);
      const basePathWithSlash = basePathWithoutSlash + '/';
      
      rootElement.innerHTML = `
        <div style="padding: 20px; color: #721c24; background-color: #f8d7da; border: 1px solid #f5c6cb; border-radius: 4px;">
          <h3>App Initialization Error</h3>
          <p>The application failed to initialize. This could be due to:</p>
          <ul>
            <li>Incorrect path configuration</li>
            <li>Missing JavaScript resources</li>
            <li>Runtime errors</li>
          </ul>
          <p>Error details: ${error.message}</p>
          <div style="margin-top: 15px;">
            <p>Try accessing the app at:</p>
            <a href="${basePathWithSlash}" style="display: inline-block; margin: 5px; padding: 8px 16px; background-color: #0275d8; color: white; text-decoration: none; border-radius: 4px;">With trailing slash</a>
            <a href="${basePathWithoutSlash}" style="display: inline-block; margin: 5px; padding: 8px 16px; background-color: #0275d8; color: white; text-decoration: none; border-radius: 4px;">Without trailing slash</a>
            <button onclick="window.location.reload()" style="display: inline-block; margin: 5px; padding: 8px 16px; background-color: #5cb85c; color: white; border: none; border-radius: 4px; cursor: pointer;">Reload Page</button>
          </div>
        </div>
      `;
    }
  }
}

// Report web vitals
reportWebVitals();
